import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Dashbar from './Dashbar';

class NoAccount extends Component {
  render() {
    return(
      <div>
        <Dashbar/>
        <div className="grid">
          <div className="info">
            <img className="icon-ui" src="https://s3-us-west-2.amazonaws.com/pinstripelabs.com/icon-graphic-brand.png" alt="Pinstripe Logo" />
            <h3>Welcome to Pinstripe</h3>
            <h5>
            Sign in to access your app dashboard.
            </h5>
            <br/>
            <Link className="btn alt" to="/signin">Sign In</Link>
            <Link className="btn" to="/signup">Sign Up</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default NoAccount;


// WEBPACK FOOTER //
// ./src/components/NoAccount.js